export enum FloatingBadgesEnum {
  PreferredProvider = 'Preferred Provider',
}
